import { ProjectLoadParams } from './project-load-dialog.component';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProjectLoadDialogService {
  public requests = new EventEmitter<ProjectLoadParams>();

  constructor() { }
  Show(params:ProjectLoadParams): void {
    this.requests.emit(params);
  }

}
